import React, { useState} from "react";

function HackingGallery() {
  const [showAll, setShowAll] = useState(false);

  const galleryImages = [
    {
      id: 1,
      url: 'https://images.pexels.com/photos/1181406/pexels-photo-1181406.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 2,
      url: 'https://images.pexels.com/photos/1181622/pexels-photo-1181622.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 3,
      url: 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 4,
      url: 'https://images.pexels.com/photos/3183190/pexels-photo-3183190.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 5,
      url: 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 6,
      url: 'https://images.pexels.com/photos/3184419/pexels-photo-3184419.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 7,
      url: 'https://images.pexels.com/photos/3184296/pexels-photo-3184296.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 8,
      url: 'https://images.pexels.com/photos/1181396/pexels-photo-1181396.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    {
      id: 9,
      url: 'https://images.pexels.com/photos/3184297/pexels-photo-3184297.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
  ];

  const displayedImages = showAll ? galleryImages : galleryImages.slice(0, 4);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#e8ecf3', padding: '40px 20px' }}>
      <div className="container" style={{ maxWidth: '1200px' }}>
        <h1
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '3rem',
            fontWeight: '400',
            color: '#1a1a1a',
            marginBottom: '40px',
            letterSpacing: '1px',
          }}
        >
          Recent Gallery
        </h1>

        <div className="row g-3">
          {displayedImages.map((image, index) => (
            <div key={image.id} className="col-md-6">
              <div
                style={{
                  border: '4px solid #4a90e2',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  height: '280px',
                }}
              >
                <img
                  src={image.url}
                  alt={`Gallery ${index + 1}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </div>
          ))}
        </div>

        {!showAll && (
          <div className="text-center" style={{ marginTop: '40px' }}>
            <button
              className="btn btn btn-lg"
              onClick={() => setShowAll(true)}
              style={{
                borderRadius: '30px',
                padding: '12px 40px',
                fontSize: '1.1rem',
                fontWeight: '500',
                backgroundColor: '#4a90e2',
                border: 'none',
                boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
              }}
            >
              Show More
            </button>
          </div>
        )}

        {showAll && (
          <div className="text-center" style={{ marginTop: '40px' }}>
            <button
              className="btn btn-secondary  btn-lg"
              onClick={() => setShowAll(false)}
              style={{
                borderRadius: '30px',
                padding: '12px 40px',
                fontSize: '1.1rem',
                fontWeight: '500',
                border: 'none',
                boxShadow: '0 4px 15px rgba(108, 117, 125, 0.3)',
              }}
            >
              Show Less
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default HackingGallery;
